import _ from 'lodash'

export function truncate (string, len = 30) {
  if (string.length > len) {
    return string.substring(0, len) + '...'
  } else {
    return string
  }
}

export function poll (fn, timeout, interval) {
  const endTime = Number(new Date()) + (timeout || 2000)
  interval = interval || 100

  const checkCondition = function (resolve, reject) {
    // If the condition is met, we're done!
    const result = fn()
    if (result) {
      resolve(result)
    } else if (Number(new Date()) < endTime) {
      // If the condition isn't met but the timeout hasn't elapsed, go again
      setTimeout(checkCondition, interval, resolve, reject)
    } else {
      // Didn't match and too much time, reject!
      reject(new Error('timed out for ' + fn + ': ' + arguments))
    }
  }

  return new Promise(checkCondition)
}

/**
 * Query-string encoding of a Javascript Object
 * @param obj
 * @param prefix
 * @return {string}
 */
export function serialize (obj, prefix) {
  let str = []

  for (let p in obj) {
    if (obj.hasOwnProperty(p)) {
      const k = prefix ? prefix + '[' + p + ']' : p
      const v = obj[p]
      str.push((v !== null && typeof v === 'object') ? serialize(v, k) : encodeURIComponent(k) + '=' + encodeURIComponent(v))
    }
  }
  return str.join('&')
}

/**
 * Convert object keys to snake case
 * @param obj
 * @return {*}
 */
export function keysToSnakeCase (obj) {
  const clone = _.cloneDeep(obj)
  _.forOwn(clone,
    (v, k) => {
      delete clone[k]
      clone[_.snakeCase(k)] = v
    })

  return clone
}

export default {
  keysToSnakeCase,
  truncate,
  serialize,
  poll
}



// WEBPACK FOOTER //
// ./src/app/helpers/index.js